<span class="container">
  <div #customTrigger><ng-content select="[menuTrigger]"></ng-content></div>
  <button
    #trigger
    class="badge-button"
    [class.rv-hidden]="customTrigger.children.length"
    [menuTrigger]="this"
    [rivTooltip]="tooltip"
    [disabled]="disabled"
    type="button"
  >
    <riv-badge [size]="badgeSize" [variant]="getBadgeVariant()">
      <span *ngIf="!!text">{{ text }}</span>
      <riv-icon
        *ngIf="!disabled"
        class="ml-small"
        [name]="icon"
        [size]="iconSize"
      ></riv-icon>
    </riv-badge>
  </button>
</span>

<ng-container *ngIf="showMenu">
  <deprecated-callout
    *deprecated-callout
    [anchor]="customTrigger.children.length ? customTrigger : trigger"
    [preferredPosition]="preferredPosition"
    (keydown)="keydown($event.key)"
    (close)="closeMenu(true)"
    tabindex="-1"
  >
    <div class="options" [class.light]="light" #menuoptions>
      <ng-container *ngIf="!light">
        <ng-container *ngTemplateOutlet="menuItemTemplate"></ng-container>
      </ng-container>
      <ng-container *ngIf="light">
        <ng-container *ngTemplateOutlet="menuItemLightTemplate"></ng-container>
      </ng-container>
    </div>
  </deprecated-callout>
</ng-container>
